module.exports = __webpack_public_path__ + "static/media/StyleProfile-Style.a1db235d.svg";